import { createAction } from '@reduxjs/toolkit';

export const resetStore = createAction('RESET_STORE');

export const logout = () => (dispatch) => {
    dispatch(resetStore());
};
